<div class="navbar">
  <img class="hgt-logo" src="/../assets/images/hgt_logo.png" (click)="onChangeMenu(0, 'company_main')"/>
  <div [ngClass]="groupKey === 1? 'active' : ''" class="subnav">
    <button class="subnavbtn">COMPANY</button>
    <div class="subnav-content">
      <a [ngClass]="pageKey === 'company_intro'? 'active' : ''" (click)="onChangeMenu(1, 'company_intro')">회사소개</a>
      <a [ngClass]="pageKey === 'ceo_message'? 'active' : ''" (click)="onChangeMenu(1, 'ceo_message')">CEO 메세지</a>
      <a [ngClass]="pageKey === 'history'? 'active' : ''" (click)="onChangeMenu(1, 'history')">연혁</a>
      <a [ngClass]="pageKey === 'organization_chart'? 'active' : ''" (click)="onChangeMenu(1, 'organization_chart')">조직도</a>
    </div>
  </div>
  <div [ngClass]="groupKey === 2? 'active' : ''" class="subnav">
    <button class="subnavbtn">PRODUCTS</button>
    <div class="subnav-content">
      <a [ngClass]="pageKey === 'semi_intro'? 'active' : ''" (click)="onChangeMenu(2, 'semi_intro')">반도체 사업</a>
      <a [ngClass]="pageKey === 'metal_intro'? 'active' : ''" (click)="onChangeMenu(2, 'metal_intro')">판금 사업</a>
    </div>
  </div>
  <div [ngClass]="groupKey === 3? 'active' : ''" class="subnav">
    <button class="subnavbtn">R&D TEAM</button>
    <div class="subnav-content">
      <a [ngClass]="pageKey === 'rnd_intro'? 'active' : ''" (click)="onChangeMenu(3, 'rnd_intro')">연구 전담 부서</a>
    </div>
  </div>
  <div [ngClass]="groupKey === 4? 'active' : ''" class="subnav">
    <button class="subnavbtn">CUSTOMER SERVICE</button>
    <div class="subnav-content">
      <!-- <a [ngClass]="pageKey === 'customer_request'? 'active' : ''" (click)="onChangeMenu(4, 'customer_request')">고객 문의</a> -->
      <a [ngClass]="pageKey === 'company_location'? 'active' : ''" (click)="onChangeMenu(4, 'company_location')">오시는 길</a>
    </div>
  </div>
</div>

<div style="padding-top: 53px" class="main-body" [ngSwitch]="pageKey">
  <app-company-main *ngSwitchCase="'company_main'"
    (onSelectViewMore)="onSelectViewMore($event)"></app-company-main>
      <app-company-introduction *ngSwitchCase="'company_intro'"></app-company-introduction>
      <app-organization-chart *ngSwitchCase="'organization_chart'"></app-organization-chart>
      <app-ceo-message *ngSwitchCase="'ceo_message'"></app-ceo-message>
      <app-history *ngSwitchCase="'history'"></app-history>
      <app-rnd-introduction *ngSwitchCase="'rnd_intro'"></app-rnd-introduction>
      <app-semi-introduction *ngSwitchCase="'semi_intro'" (goToCustomerRequest)="onClickGotoMenu($event)"></app-semi-introduction>
      <app-metal-introduction *ngSwitchCase="'metal_intro'" (goToCustomerRequest)="onClickGotoMenu($event)"></app-metal-introduction>
      <app-company-location *ngSwitchCase="'company_location'"></app-company-location>
      <!-- <app-customer-request *ngSwitchCase="'customer_request'"
        [productType]="selectedProductType">
      </app-customer-request> -->
</div>
